'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var ReactDOM = require('react-dom');
var cx = require('classnames');
var bodyScrollLock = require('body-scroll-lock');
var FocusLock = require('react-focus-lock');
var SVGIcon = require('@arrive/svg-icon');
var CLOSE = require('@arrive/ui-icons/svg/ic_close.svg');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);
var cx__default = /*#__PURE__*/_interopDefaultLegacy(cx);
var FocusLock__default = /*#__PURE__*/_interopDefaultLegacy(FocusLock);
var SVGIcon__default = /*#__PURE__*/_interopDefaultLegacy(SVGIcon);
var CLOSE__default = /*#__PURE__*/_interopDefaultLegacy(CLOSE);

var styles = {"ethanol":"#fff","tandem":"#f4f5f5","chrome":"#d4d6d9","LFGray":"#9ea2a9","smokey":"#60646c","burnout":"#46494f","roadhog":"#303236","axle":"#1d1e20","grease":"#0a0a0b","bandit":"#e0f3fb","bigSky":"#b1e1f5","arrive":"#2aaae2","blueBayou":"#039ddd","nightTime":"#007dbc","blueridge":"#0062c0","gasoline":"#feefcb","diesel":"#f1ae11","mileMarker":"#e8f5e9","gatorguts":"#4caf50","frogger":"#2b731a","whoaNelly":"#ffedf1","jackknife":"#cb2024","overlay":"arrive_Modal__overlay","closeButton":"arrive_Modal__closeButton","modalPosition":"arrive_Modal__modalPosition","modal":"arrive_Modal__modal","modalBody":"arrive_Modal__modalBody","headerBar":"arrive_Modal__headerBar","footerBar":"arrive_Modal__footerBar"};

/**
 * Name that will be shown in the Styleguide
 * @visibleName Modal
 */

var ModalBody = function ModalBody(_ref) {
  var children = _ref.children,
      _ref$preventBodyScrol = _ref.preventBodyScroll,
      preventBodyScroll = _ref$preventBodyScrol === void 0 ? true : _ref$preventBodyScrol,
      className = _ref.className;
  var bodyRef = React.useRef();
  React.useEffect(function () {
    var hasLock = false;

    if (preventBodyScroll && bodyRef.current) {
      hasLock = true;
      bodyScrollLock.disableBodyScroll(bodyRef.current);
    } else if (bodyRef.current) {
      hasLock = false;
      bodyScrollLock.enableBodyScroll(bodyRef.current);
    }

    return function () {
      if (hasLock) {
        bodyScrollLock.clearAllBodyScrollLocks();
      }
    };
  }, [preventBodyScroll, bodyRef]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    ref: bodyRef,
    className: cx__default["default"](styles.modalBody, className)
  }, children);
};
ModalBody.propTypes = {
  children: PropTypes__default["default"].node.isRequired,
  preventBodyScroll: PropTypes__default["default"].bool,
  className: PropTypes__default["default"].string
};
var ModalFooter = function ModalFooter(_ref2) {
  var children = _ref2.children,
      className = _ref2.className;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](styles.footerBar, className)
  }, children);
};
ModalFooter.propTypes = {
  children: PropTypes__default["default"].node.isRequired,
  className: PropTypes__default["default"].string
};
var ModalHeader = function ModalHeader(_ref3) {
  var title = _ref3.title,
      children = _ref3.children,
      className = _ref3.className;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](styles.headerBar, className)
  }, /*#__PURE__*/React__default["default"].createElement("h3", null, title), children);
};
ModalHeader.propTypes = {
  title: PropTypes__default["default"].node,
  children: PropTypes__default["default"].node.isRequired,
  className: PropTypes__default["default"].string
};
var ModalCloseButton = function ModalCloseButton(_ref4) {
  var onClick = _ref4.onClick,
      className = _ref4.className;
  return /*#__PURE__*/React__default["default"].createElement("button", {
    "aria-label": "close modal",
    onClick: onClick,
    className: cx__default["default"](styles.closeButton, className)
  }, /*#__PURE__*/React__default["default"].createElement(SVGIcon__default["default"], {
    svgRef: CLOSE__default["default"]
  }));
};
ModalCloseButton.propTypes = {
  onClick: PropTypes__default["default"].func.isRequired,
  className: PropTypes__default["default"].string
};

var Modal = function Modal(_ref5) {
  var children = _ref5.children,
      className = _ref5.className,
      _ref5$closeOnEsc = _ref5.closeOnEsc,
      closeOnEsc = _ref5$closeOnEsc === void 0 ? true : _ref5$closeOnEsc,
      setShowModal = _ref5.setShowModal,
      focusLockShards = _ref5.focusLockShards,
      _ref5$closeOnOutsideC = _ref5.closeOnOutsideClick,
      closeOnOutsideClick = _ref5$closeOnOutsideC === void 0 ? false : _ref5$closeOnOutsideC;
  var modalPosition = React.useRef();
  React.useEffect(function () {
    if (closeOnEsc) {
      var closeOnEscape = function closeOnEscape(evt) {
        if (evt.keyCode === 27) {
          setShowModal(false);
        }
      };

      document.addEventListener("keydown", closeOnEscape);
      return function () {
        document.removeEventListener("keydown", closeOnEscape);
      };
    }
  }, [closeOnEsc, setShowModal]);

  var handleOutsideClick = function handleOutsideClick(evt) {
    if (closeOnOutsideClick && evt.target === modalPosition.current) {
      setShowModal(false);
    }
  };

  return /*#__PURE__*/ReactDOM__default["default"].createPortal( /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: styles.overlay
  }), /*#__PURE__*/React__default["default"].createElement(FocusLock__default["default"], {
    autoFocus: false,
    shards: focusLockShards
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    "data-testid": "modal-position",
    ref: modalPosition,
    className: styles.modalPosition,
    onClick: handleOutsideClick
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: cx__default["default"](styles.modal, className)
  }, children)))), document.getElementById('portalTarget'));
};

Modal.displayName = 'Modal';
Modal.propTypes = {
  children: PropTypes__default["default"].node.isRequired,
  setShowModal: PropTypes__default["default"].func.isRequired,
  allowBackgroundScroll: PropTypes__default["default"].bool,
  className: PropTypes__default["default"].string,
  closeOnEsc: PropTypes__default["default"].bool,
  closeOnOutsideClick: PropTypes__default["default"].bool,
  focusLockShards: PropTypes__default["default"].array
};

exports.ModalBody = ModalBody;
exports.ModalCloseButton = ModalCloseButton;
exports.ModalFooter = ModalFooter;
exports.ModalHeader = ModalHeader;
exports["default"] = Modal;
